import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { useOfflineStatus } from '../../OfflineStatusIndicator';
import {
  initOfflineDB, saveSimulationOffline,
  getLocalSimulations, deleteLocalSimulation,
} from '../../../services/offlineService';

export default function useOfflineMode({ userId }) {
  const { isOnline, unsyncedCount } = useOfflineStatus();
  const [localSimulations, setLocalSimulations] = useState([]);
  const [showLocalSimulations, setShowLocalSimulations] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        await initOfflineDB();
        const sims = await getLocalSimulations('domium');
        setLocalSimulations(sims);
      } catch {}
    };
    load();
  }, []);

  const saveToLocal = useCallback(async (simulationData) => {
    try {
      const savedSim = await saveSimulationOffline({
        ...simulationData, type: 'domium', user_id: userId,
      });
      setLocalSimulations(prev => {
        const idx = prev.findIndex(s => s.id === savedSim.id);
        if (idx >= 0) { const updated = [...prev]; updated[idx] = savedSim; return updated; }
        return [...prev, savedSim];
      });
      return savedSim;
    } catch { return null; }
  }, [userId]);

  const handleDeleteLocalSimulation = useCallback(async (simId) => {
    try {
      await deleteLocalSimulation(simId);
      setLocalSimulations(prev => prev.filter(s => s.id !== simId));
      toast.success('Simulation supprimee');
    } catch { toast.error('Erreur suppression'); }
  }, []);

  return {
    isOnline, unsyncedCount,
    localSimulations, setLocalSimulations, showLocalSimulations, setShowLocalSimulations,
    saveToLocal, handleDeleteLocalSimulation,
  };
}
